import { render } from "./OrderheaderMobile.vue?vue&type=template&id=7a1506b3&scoped=true"
import script from "./OrderheaderMobile.vue?vue&type=script&lang=js"
export * from "./OrderheaderMobile.vue?vue&type=script&lang=js"

import "./OrderheaderMobile.vue?vue&type=style&index=0&id=7a1506b3&scoped=true&lang=css"

import exportComponent from "/Users/dejth/Workspace/nakee-order-detail/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7a1506b3"]])

export default __exports__